/* eslint-disable no-unused-vars */
/* eslint-disable max-len */
export default function flipAction(direction, ctxMain, canvasMain, copyCanvas, canvasCur, returnCurrentFrame) {
  const frameSrc = canvasMain.toDataURL('image/png');
  const frame = new Image();
  frame.src = frameSrc;
  ctxMain.save();
  ctxMain.clearRect(0, 0, canvasMain.width, canvasMain.height);
  if (direction === 'horizontal') {
    ctxMain.translate(canvasMain.width, 0);
    ctxMain.scale(-1, 1);
  }
  if (direction === 'vertical') {
    ctxMain.translate(0, canvasMain.height);
    ctxMain.scale(1, -1);
  }
  ctxMain.drawImage(frame, 0, 0);
  console.log('frame2: ', frame);
  ctxMain.restore();
  const frameSrc2 = canvasMain.toDataURL('image/png');
  const frame2 = new Image();
  frame2.src = frameSrc2;
  ctxMain.drawImage(frame2, 0, 0);
  copyCanvas(canvasMain, canvasCur(returnCurrentFrame()));
}
